import { TableKey } from 'models/schema'

const customPanelTitles: Record<TableKey, string> = {
  futureSales: 'les ventes futures',
  futureSalesDetail: 'les détails des ventes futures',
  salesResult: 'les résultats de ventes',
  salesResultDetail: 'les détails des résultats de vente',
  search: 'les résultats de recherche',
  stock: ' le stock',
  waitingFiles: 'les dossiers en attentes',
  history: "l'historique des modifications de réserve",
}

export { customPanelTitles }
